import { InjectionToken } from "@angular/core";
import { IAuthenticationAppRouterService } from "../interfaces/authentication-app-router-service";
import { IInternalApiConfig } from "../interfaces/internal-api-config";

/**
 * This is the token for the IInternalApiConfig it is used internally for the library
 *
 * It is included in the public library for testing only. Applications should use there own APP_CONFIG token
 */
export const INTERNAL_API_APP_CONFIG = new InjectionToken<IInternalApiConfig>("INTERNAL_API_APP_CONFIG");

/**
 * Used to inject the IAPI APP Router Service
 *
 * It is included in the public library for testing only. Applications should use there own AppRouter class
 */
export const IAPI_APP_ROUTER_SERVICE = new InjectionToken<IAuthenticationAppRouterService>("IAPI_APP_ROUTER_SERVICE");
